<template>
  <b-row>
    <b-col cols="4">
     <BfInput
        label="Clave"
        data-key="clave"
        :value="data.clave"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        v-if="!allowSearch"
        label="Nombre"
        data-key="nombre"
        :value="data.nombre"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
      <BfAutocomplete
        v-else
        label="Nombre"
        data-key="nombre"
        :value="data.nombre"
        :fetch-suggestions="autocompleteNameSearch"
        :trigger-on-focus="false"
        @input="selectNameOption"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
        <b-col cols="4">
     <!--  <BfAutocomplete
        label="DNI / CIF"
        :value="data.nif"
        data-key="nif"
        :fetch-suggestions="autocompleteNifSearch"
        :trigger-on-focus="false"
        :errors="errors"
        @input="selectNifOption"
        @update="updateForm"
      /> -->
    </b-col>
      <b-col cols="4">
      <BfInput
         v-if="!editing"
        label="Código Postal"
        data-key="codigopostal"
        :value="data.codigopostal"
        :readonly="readonly"
        :errors="errors"
        @update="updateCodigoPostal"
      />
       <BfInput
         v-else
        label="Código Postal"
        data-key="codigopostal"
        :value="data.codigopostal"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="8">
      <BfInput
        label="Dirección"
        data-key="direccion"
        :value="data.direccion"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Población"
        data-key="poblacion"
        :value="data.poblacion"
        :edit-mode="editing"
        readonly
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Provincia"
        data-key="provincia"
        :value="data.provincia"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        readonly
      />
    </b-col>
    <b-col  cols="4"></b-col>
     <b-col cols="4">
      <BfInput
        label="Teléfono"
        data-key="telefono1"
        :value="data.telefono1"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Email"
        data-key="email"
        :value="data.email"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="6">

   <!--  <BfInput
        label="Observaciones"
        data-key="observaciones"
        :value="data.observaciones"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
        type="textarea"
        :autosize="{ minRows: 5, maxRows: 10 }"
      /> -->
      </b-col>
   <!-- <b-col cols="4">
      <BfInput
        label="Clave"
        data-key="clave"
        :value="data.clave"
        :edit-mode="editing"
        :readonly="readonly"
        :errors="errors"
        @update="updateForm"
      />
    </b-col> -->
  </b-row>
</template>

<script>
import { clientAPI, chargeAPI } from '@/api';

const autocompleteRequest = async (params = {}) => {
  const {
    data: { data = [] },
  } = await clientAPI.getAll({
    perPage: 999,
    ...params,
  });

  return data;
};

export default {
  name: 'ApplicantForm',

  props: {
    allowSearch: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
  },

  data() {
    return {
      autocompleteNameOptions: [],
      autocompleteNifOptions: [],
    };
  },

  methods: {
    async autocompleteNifSearch(query, cb) {
      if (query.length >= 2) {
        const data = await autocompleteRequest({ nif: query });

        this.autocompleteNifOptions = data;
        const formatted = data.map(({ nif }) => ({
          value: nif,
        }));
        cb(formatted);
      }
    },

    async autocompleteNameSearch(query, cb) {
      if (query.length >= 2) {
        const data = await autocompleteRequest({ search: query });

        this.autocompleteNameOptions = data;
        const formatted = data.map(({ nombre }) => ({
          value: nombre,
        }));
        cb(formatted);
      }
    },
    async updateCodigoPostal({ value }) {
      const valueLength = value.length;
      console.log(`${value} / ${valueLength}`);
      if (valueLength >= 5) {
        try {
          const datosCp = await chargeAPI.autoCodigosPostales(value);
          this.data.provincia = datosCp.provincia;
          this.data.poblacion = datosCp.poblacion;
          this.data.codigopostal = value;
        } catch ({ errors, message }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message,
            type: 'error',
          });
        }
      }
    },

    selectNifOption(value) {
      const selected = this.autocompleteNifOptions.find(option => option.nif === value) || {};

      this.emitSelected(selected);
    },

    selectNameOption(value) {
      const selected = this.autocompleteNameOptions.find(option => option.nombre === value) || {};

      this.emitSelected(selected);
    },

    emitSelected(selected) {
      this.$emit('select-search-item', selected);
    },

    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
  },
};
</script>
